import type {MonthColumn} from "../../utils";
import {ShimmerBar} from "../skeletonParts.tsx";
import {COL_SEP_L, COL_SEP_R, STICKY_COLUMN_WIDTH} from "./tableStyles.ts";

export function AccountHeaderCell() {
    return (
        <th
            className={`sticky left-0 z-20 px-3 py-3 text-left text-[13px] font-semibold text-gray-900 ${COL_SEP_R} bg-gray-50`}
            style={{minWidth: `${STICKY_COLUMN_WIDTH}px`}}
        >
            Rekening
        </th>
    );
}

interface MonthHeaderCellsProps {
    columns: MonthColumn[];
    showPlaceholders: boolean;
    separateFirst: boolean;
}

export function MonthHeaderCells({columns, showPlaceholders, separateFirst}: MonthHeaderCellsProps) {
    return (
        <>
            {columns.map((column, index) => (
                <th
                    key={column.label}
                    title={showPlaceholders ? undefined : column.label}
                    className={`px-3 py-3 text-right text-[12px] font-semibold text-gray-700 whitespace-nowrap ${
                        index === 0 && !separateFirst ? "" : COL_SEP_L
                    }`}
                >
                    {showPlaceholders ? (
                        <ShimmerBar className="ml-auto" style={{width: "2.5rem"}} />
                    ) : (
                        column.shortLabel
                    )}
                </th>
            ))}
        </>
    );
}
